export default {
  initialize: state => ({
    type: 'DATA_PROPERTIES_INITIALIZE',
    state,
  }),
  setProperties: properties => ({
    type: 'DATA_PROPERTIES_SET_PROPERTIES',
    properties,
  }),
  setCustomProperties: customProperties => ({
    type: 'DATA_PROPERTIES_SET_CUSTOM_PROPERTIES',
    customProperties,
  }),
  setFixedProperties: fixedProperties => ({
    type: 'DATA_PROPERTIES_SET_FIXED_PROPERTIES',
    fixedProperties,
  }),
  setSelectedProperties: selectedProperties => ({
    type: 'DATA_PROPERTIES_SET_SELECTED_PROPERTIES',
    selectedProperties,
  }),
  setSortDirection: sortDirection => ({
    type: 'DATA_PROPERTIES_SET_SORT_DIRECTION',
    sortDirection,
  }),
  setSortKey: sortKey => ({
    type: 'DATA_PROPERTIES_SET_SORT_KEY',
    sortKey,
  }),
  setSearchValue: searchValue => ({
    type: 'DATA_PROPERTIES_SET_SEARCH_VALUE',
    searchValue,
  }),
};
